import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { SohoDataGridComponent, SohoModalDialogService, SohoBusyIndicatorDirective } from "ids-enterprise-ng";
import { CapacityModelService } from "../services/CapacityModel-Service";
import { Router, NavigationExtras } from "@angular/router";
import { AuthHelper } from './../services/authHelper';
import { UserData } from '../shared/models/user.model';

@Component({
  selector: 'app-territory-budgets',
  templateUrl: './territory-budgets.component.html',
  styleUrls: ['./territory-budgets.component.css']
})
export class TerritoryBudgetsComponent implements OnInit {
  @ViewChild(SohoDataGridComponent) sohoDataGridComponent!: SohoDataGridComponent;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator?: SohoBusyIndicatorDirective;
  public data!: any[];
  public grid_Columns!: SohoDataGridColumn[];
  public filteredArray: any[] = [];
  public GrdRequests: any;
  public filteredRequests: any;
  public filteredIds: any[] = [];
  showBusy = true;
  Message = "Loading...";
  emailAddress!: string;
  userData = new UserData();

  constructor(private capacityModelService: CapacityModelService,
    private router: Router,
    private ngZone: NgZone,
    private authhelper: AuthHelper,
    private modalService: SohoModalDialogService) { }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("userprofile")!);
    if (this.userData!= null && this.userData!=undefined) {     
      this.emailAddress = this.userData.Email;
      this.GetTerritoryBudgets();
    }   
 
  }
  start() {
    (this.busyIndicator as any).activated = true;
  }

  stop() {
    (this.busyIndicator as any).activated = false;
  }

  timer() {
    (this.busyIndicator as any).activated = true;
    setTimeout((_f: any) => (this.busyIndicator as any).activated = false, 10000);
  }
  GetTerritoryBudgets() {
    this.data = [];
    this.grid_Columns = [];
    this.start();
    this.capacityModelService.GetTerritoryBudgetsData(this.userData.Email).subscribe(
      territory => {
        this.data = territory;
        this.grid_Columns = this.gridColumns;
        if (this.data != null) {
          this.GrdRequests = $("#Requestdatagrid").datagrid().data();
          this.GrdRequests.datagrid.renderRows();
          this.stop();
        }
      },
      (error: Response) => {
        this.stop();
        console.log(error);
      }
    );
  }
  onClick(args: any) {
    console.log(args);
    localStorage.setItem("uniqueid", args["0"].item.uniqueid);
    let navigationExtras: NavigationExtras = {
      queryParams: {
        uniqueid: args["0"].item.uniqueid
      }
    };
    //$("#divTerritoryBudgets").removeClass("is-selected");
    //$("#divTerritoryBudgets").addClass("is-selected");
    this.ngZone.run(() => this.router.navigate(["EditTerritoryBudget"], navigationExtras)).then();
    //this.router.navigate(["EditProject"], navigationExtras);
  }

  DeleteBudgets() {
    let selectedid: any[] = [];
    let filterid!: any;
    this.filteredArray = [];
    var selectedRowsCount = this.GrdRequests.datagrid.selectedRows().length;
    console.log(selectedRowsCount);
    if (selectedRowsCount <= 0) {
      this.filteredArray = [];
    }
    else {

      for (var i = 0; i < selectedRowsCount; i++) {
        this.filteredRequests = false;
        if (this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered == undefined) {
          this.filteredRequests = true
        }
        else if (!this.GrdRequests.datagrid.selectedRows()[i].data.isFiltered) {
          this.filteredRequests = true
        }
        if (this.filteredRequests) {
          this.filteredIds = this.GrdRequests.datagrid.selectedRows()[i].data.uniqueid;
          this.filteredArray.push(this.filteredIds);
        }
      }
    }
    if (this.filteredArray.length > 0) {
      this.start();
      for (var i = 0; i < this.filteredArray.length; i++) {
        filterid = <JSON><unknown>{ "uniqueid": this.filteredArray[i], "userlogin": this.emailAddress == null ? "rameshbabu.kollu@infor.com" : this.emailAddress };
        selectedid.push(filterid);
      }
      this.capacityModelService.DeleteTerritoryBudgets(selectedid).subscribe(
        response => {
          this.ShowAlert("Confirmation", "Territory Budgets deleted successfully.");
          this.stop();
          this.GetTerritoryBudgets();
        },
        (error: Response) => {
          console.log(error);
          this.stop();
          this.ShowAlert("Alert", "Error while deleting the Territory Budget/s.");
        }
      );
    }
    else {
      this.ShowAlert("Information", "Please select atleast one Territory Budget to delete.");
    }
  }

  ShowAlert(Title: any, Message: any) {
    const dialogRef1 = this.modalService
      .message("<h2>" + Message + "</h2>")
      .buttons([
        {
          text: "Ok",
          click: () => {
            dialogRef1.close("Ok");
          },
          isDefault: true
        }
      ])
      .title(Title)
      .open()
      .frameHeight(1000);
  }

  gridColumns = [
    {
      id: 'selectionCheckbox',
      sortable: false,
      resizable: false,
      formatter: Soho.Formatters.SelectionCheckbox,
      align: 'center'
    },
    {
      id: "button-formatter",
      name: "Edit",
      text: "Edit Row",
      icon: "edit",
      align: "center",
      sortable: false,
      formatter: Soho.Formatters.Button,
      click: (e: any, args: any) => this.onClick(args)
    },
    {
      id: "uniqueid",
      name: "Budget ID",
      field: "uniqueid",
      hidden: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "lob",
      name: "LOB",
      field: "lob",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "managerhcmid",
      name: "Manager HCM",
      field: "managerhcmid",
      filterType: 'text',
      sortable: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "territoryname",
      name: "Territory",
      sortable: true,
      field: "territoryname",
      filterType: 'text',

      formatter: Soho.Formatters.Text
    },
    {
      id: "headcount",
      name: "Head Count",
      field: "headcount",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "budgetedquota",
      name: "Budgeted Quota",
      field: "budgetedquota",
      filterType: 'decimal',
      formatter: Soho.Formatters.Decimal,
      numberFormat: { minimumFractionDigits: 2, maximumFractionDigits: 2, round: true }
    },
    {
      id: "quotacurrency",
      name: "Quota Currency",
      field: "quotacurrency",
      filterType: 'text',
      sortable: true,
      formatter: Soho.Formatters.Text
    },
    {
      id: "lobcoverage",
      name: "LOB Coverage",
      field: "lobcoverage",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "managercoverage",
      name: "Manager Coverage",
      field: "managercoverage",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "fiscalyear",
      name: "Fiscal Year",
      field: "fiscalyear",
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "requestid",
      name: "Request ID",
      hidden: true,
      field: "requestid",
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "createdby",
      name: "Created By",
      field: "createdby",
      filterType: 'text',
      sortable: false,
      formatter: Soho.Formatters.Text
    },
    {
      id: "created",
      name: "Created On",
      field: "created",
      filterType: 'date',
      formatter: Soho.Formatters.Date,
      dateFormat: 'M/d/yyyy hh:mm:ss'
    }
  ];
}
